













import { defineComponent } from '~/utils/nuxt3-migration'
import CButton from '~/components/shared/configurable/button/CButton.vue'
import CContainer from '~/components/shared/configurable/grid/CContainer.vue'

export default defineComponent({
  components: {
    CContainer,
    CButton
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    ariaRole: {
      type: String,
      default: 'group'
    },
    vertical: {
      type: Boolean,
      default: false
    }
  }
})
